import GlobalStore from "@ipru-common/store/GlobalStore";
import getSignatureUlipNetCoreInput from "./SignatureNetCoreInput";
import { PRODUCT_NAMES } from "@ipru-common/constants/products";
import { getQdataData, getSelectedFunds, isCustomSavingPage } from "../CommonFunctions";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";

const getSignatureAssureNetCoreInput = () => {
  const { quoteFormData, calculatorFormData, appFormData, navFundReleasedCode } = GlobalStore.getSnapshot();
  let signatureAssureInput = getSignatureUlipNetCoreInput();
  const { familyIncomePercent } = quoteFormData;
  const selectedfunds = quoteFormData?.allocatedFunds ? getSelectedFunds(quoteFormData?.allocatedFunds) : 0;
  const selectedfund = selectedfunds[0] ?? "";
  const data = getQdataData();
  const agentId = data?.agentCode;
  const lmsId = data?.LMS_ID;

  function getOnlineReturnByRate(rate) {
    const items = quoteFormData?.calculatedData?.returns?.arr || [];
    const match = items.find((item) => item.rateOfInterest === rate);
    return match?.onlineReturn || null;
  }

  signatureAssureInput = {
    ...signatureAssureInput,
    "familyincome%": familyIncomePercent,
    sourceurl: signatureAssureInput?.sourceurl,
    currentPageStep: signatureAssureInput?.currentpagestep,
    isEnglish: signatureAssureInput?.isenglish,
    savingspercentage: signatureAssureInput?.savingspercentage,
    samultiple: "",
    lifecovernew: "",
    internationalmobileno: calculatorFormData?.mobileno,
    adbterm: "",
    accidental_death_benefit: "",
    nriarrivingdate: appFormData?.personalDetails?.nri_arriving_date,
    state: calculatorFormData?.state,
    lduid: signatureAssureInput?.uid,
    qdata_pasa: signatureAssureInput?.qdata_pasa,
    outputobjhold_4: getOnlineReturnByRate(4),
    outputobjhold_8: getOnlineReturnByRate(8),
    fund_name: selectedfunds?.length > 0 ? selectedfunds[0]?.Fund : (quoteFormData?.selectedFund ?? ""),
    NFOopt: navFundReleasedCode ? String(quoteFormData?.nfoOpt || OPTION_VALUES.N_NO).toLowerCase() : undefined,
  };
  const maturityBenefitValue = quoteFormData?.calculatedData?.returns?.pastPerformance?.onlineReturn;

  if (isCustomSavingPage()) {
    signatureAssureInput = {
      ...signatureAssureInput,
      page_title: PRODUCT_NAMES.SignatureAssured,
      fund_performance_1: selectedfund?.Perf1Year ?? "",
      fund_performance_3: selectedfund?.Perf3Year ?? "",
      fund_performance_5: selectedfund?.Perf5Year ?? "",
      fund_performance_10: selectedfund?.Perf10Year ?? "",
      fund_performance_rsi: selectedfund?.PerfInception ?? "",
      maturity_benefit_1fp: quoteFormData?.returnYears === 1 ? maturityBenefitValue : "",
      maturity_benefit_3fp: quoteFormData?.returnYears === 3 ? maturityBenefitValue : "",
      maturity_benefit_5fp: quoteFormData?.returnYears === 5 ? maturityBenefitValue : "",
      maturity_benefit_10fp: quoteFormData?.returnYears === 10 ? maturityBenefitValue : "",
      maturity_benefit_rsifp: quoteFormData?.returnYears === 1 ? maturityBenefitValue : "",
      swp_opted: quoteFormData?.swpExpand == "Yes" ? "Yes" : "No",
      swp_type_opted: quoteFormData?.swpExpand == "Yes" ? (quoteFormData?.Goal ?? "") : "",
      agentid: agentId,
      lmsid: lmsId,
      trai_flag: "Yes",
      fund_name: selectedfunds?.length > 0 ? selectedfunds[0]?.Fund : (quoteFormData?.selectedFund ?? ""),
    };
  }
  return signatureAssureInput;
};

export default getSignatureAssureNetCoreInput;
